import { Divider, type MenuItemProps } from '@mui/material';
import ImageUploadOption from './ImageUploadOption';
import device from 'current-device';
import isTouchDevice from '@/lib/utils/isTouchDevice';

export type AddImageMenuItemProps = Omit<MenuItemProps, 'onClick' | 'children'>;

type ImageUploadControlsProps = AddImageMenuItemProps & {
  onUploadImages: (imageFiles: File[]) => Promise<void>;
  onLoadStart: () => string;
  onLoadEnd: (loaderId: string) => void;
  onRegisterError: () => string;
  onRemoveError: (errorId: string) => void;
  onRegisterWarning: () => string;
  onRemoveWarning: (warningId: string) => void;
};

const ImageUpload = (props: ImageUploadControlsProps) => {
  // On mobile devices, a camera is likely available. iOS automatically shows
  // a "take photo" option when clicking a file input, but non-iOS devices
  // don't per se. So, for non-iOS devices, manually show a "take photo"
  // option.
  if (isTouchDevice() && !device.ios()) {
    return (
      <>
        <Divider />
        <ImageUploadOption variant="select_image" {...props} />
        <ImageUploadOption variant="take_photo" {...props} />
      </>
    );
  }

  return <ImageUploadOption variant="add_image_generic" {...props} />;
};

export default ImageUpload;
